export default "/assets/images/mila-box.fb19ea76d127dbcb.webp";